export default __webpack_public_path__ + "994e27b.png";